import React from 'react';
import styles from './ChatMainPanel.module.css';

interface ChatMainPanelProps {
  children: React.ReactNode;
}

const ChatMainPanel: React.FC<ChatMainPanelProps> = ({ children }) => {
  return (
    <div className={styles.mainPanel}>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default ChatMainPanel;